"use client";

import { getSiteFlags } from "../helpers/get-site-flags";
import { useRouterInfo } from "./use-router-info";

export const useSiteInfo = () => {
  const { locale } = useRouterInfo();

  return getSiteFlags(locale);
};
